'use strict';

angular.module('licensure.services')
    .factory('TrainingFields', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/EducationModule/GetSelfEnteredCourseFields', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;